import styles from "../../styles/pages/herkunft/gebiet.module.css"
import Collapsible from "../../components/collapsible/collapsible";
import Layout from "../../components/shared/layout/layout";
import Link from "next/link";
import Seo from "../../components/shared/seo/seo";


export default function Ortschaften() {
    return (
        <Layout>
            <Seo title="Gebiet" description="Das Weinbaugebiet rund um das Weingut Gisperg." path="/herkunft/gebiet" />
            <section className=" background_light_texture vertical-center no_fill smaller">
                <Link href="/herkunft">
                    <p className="marker-back goBack annotation white"><b>Zurück</b></p>
                </Link>
                <h1 className="white">Gebiet</h1>
            </section>
            <section className="background_lighter ">
                <div className="col-4">
                    <h2>Thermenregion</h2>
                    <p className="robertson subtitle brown" style={{marginTop: "-40px"}}>Niederösterreich</p>
                    <p className="center-text">Die besondere geografische Lage, die kalkdomminierten Geologie, das pannonischen Klima und die mehr als 2000 Jahre Geschichte beeinflussen den Charakter der Weine der Thermenregion maßgeblich. </p>
                </div>
                <div className="horizontal">
                    <div className="col-3">
                        <Link href="#lage"><p className="brown annotation marker link">Geografische Lage</p></Link>
                    </div>
                    <div className="col-3">
                        <Link href="#sorten"><p className="brown annotation marker link">Sorten</p></Link>
                    </div>
                    <div className="col-3">
                        <Link href="#ursprung"><p className="brown annotation marker link">Ursprung</p></Link>
                    </div>
                </div>
                <div className="horizontal">
                    <div className="col-3 right">
                        <Link href="#geologie"><p className="brown annotation marker link">Geologie</p></Link>
                    </div>
                    <div className="col-3 left">
                        <Link href="#klima"><p className="brown annotation marker link">Klima</p></Link>
                    </div>
                </div>
            </section>
            <section className="background_light ">
                <span  className="anchor" id="lage" ></span>
                <div className="horizontal">
                    <div className="col-6 left" style={{marginRight:"25px"}}>
                        <h3>Geografische Lage</h3>
                        <p>Es grenzt direkt an den südlichen Stadtrand Wiens und verläuft von dort entlang dem Westrand des Wienerwalds gen Südwest. Der Wienerwald bildet eine Hügelkette, an deren Abhänge und Ausläufer sich die Weingärten schmiegen und nach Süd, bis Südost ausgerichtet sind. Genau genommen besteht die Thermenregion aus einem nordwestlichen und einem südöstlichen Bereich.
                            <br/><br/>
                            Die Weingüter der Thermenregion verteilen sich auf 42 Weinbauorte, wobei als wichtigste Weinbaugemeinden Teesdorf, Tattendorf, Gumpoldskirchen, Sooß, Guntramsdorf, Perchtoldsdorf, Pfaffstätten, Bad Vöslau, Baden, und Traiskirchen gelten. </p>
                    </div>
                    <div className="col-6" style={{marginLeft:"25px"}}>
                        <img alt=""  src="/images/thermenregion_world.png" width="674" height="390"/>
                    </div>
                </div>
            </section>
            <section className="background_light ">
                <span  className="anchor" id="sorten" ></span>
                <div className="horizontal">
                    <div className="col-6" style={{marginLeft:"25px"}}>
                        <img alt=""  src="/images/hektar.png" style={{scale:"0.8"}} width="510" height="396"/>
                    </div>
                    <div className="col-6 left" style={{marginRight:"25px"}}>
                        <h3>Sorten</h3>
                        <p>Das Gebiet umfasst 1901 Hektar Rebfläche. Das Steinfeld wird geprägt von den Weinen aus der Burgunderfamilie (Weißburgunder, Pinot Gris, Chardonnay, Pinot Noir & St.Laurent) und Zweigelt.
                            <br/><br/>
                            In kleinerem Ausmaß vertreten sind auch Merlot und Cabernet Sauvignon. An den Hängen des Wienerwaldes sind die autochthonen Rebsorten Zierfandeler (Spätrot) und Rotgipfler zu finden. </p>
                    </div>
                </div>
            </section>
            <section className="background_light_texture ">
                <span  className="anchor" id="ursprung" ></span>
                <div className="horizontal">
                    <div className="col-6 left">
                        <h3 className="white">Ursprung</h3>
                        <p className="narrow">Schon vor mehr als 2000 Jahren wurden in der klimatisch begünstigten Region südlich von Wien Weinreben von Kelten und Römern kultiviert. Römische Legionäre, die hier stationiert waren, brachten Weinstöcke aus ihrer Heimat und Kenntnisse über die Weinerzeugung nach Pannonien. Der Name Thermenregion verweist auf die schwefelhaltigen heißen Quellen von Aquae (Baden).
                            <br/><br/>
                            Im Mittelalter erlebte hier der Weinbau unter Federführung der Zisterziensermönche eine regelrechte Hochblüte. Bereits 1141 gründeten Zisterziensermönche das Weingut Thallern. Die Anlage der Rebberge, aber auch der Charakter der Dörfer lassen deutlich den Einfluss aus dem burgundischen Mutterkloster Citeaux erkennen. Die zisterziensischen Weinbauexperten hatten den Wert dieses außerordentlichen Terroirs sofort erkannt.  Der Hochadel sprach bevorzugt dem hier gekelterten Wein zu und trug viel zu dessen Popularität bei.
                        </p>
                    </div>
                    <div className="col-6">
                        <img alt=""  src="/images/ursprung.webp" style={{mixBlendMode:"multiply"}} width="607" height="290"/>
                        <p className="narrow">Ab dem 14. Jahrhundert setzten rege Handelstätigkeiten mit Wein ein. Herkunftsmarken wie Gumpoldskirchner für Weißwein oder Vöslauer für Rotwein standen für höchste Qualität und zu international begehrten Marken avancierten.
                            <br/><br/>
                            Das neue österreichische Weingesetz im Jahr 1985 markiert den Beginn einer zweiten Geburtsstunde für das Gebiet. Damals wurden die ehemals eigenständigen Weinbaugebiete Gumpoldskirchen und Bad Vöslau zur heutigen Thermenregion vereint. </p>
                    </div>
                </div>
                <div className="col-12">
                    <p className="button secondary dark x2">Zur Geschichte</p>
                </div>
            </section>

            <section className="background_lighter">
                <span  className="anchor" id="geologie" ></span>
                <div className="horizontal">
                    <div className="col-6 left">
                        <h3>Geologie</h3>
                        <p>Das Weinbaugebiet erstreckt sich am Ostrand der Kalkalpen zum Wiener Becken. Nur ein geringer Teil der Weingärten liegt aber direkt auf festen Kalk- und Dolomitgestein oder auf den Sandsteinen und Konglomeraten der Gosau-Gruppe.
                            <br/><br/>
                            Die meisten Reben stehen auf Ablagerungen des einstigen Meeres und des Pannon Sees im Wiener Becken oder auf kaltzeitlichen Flussschottern in der Ebene des Steinfeldes. Beckenwärts stehen die Weingärten vielfach auf feinkörnigen Tonen, Mergeln, Hangschutt oder Kolluvium, darauf entwickeln sich lehmige Böden vielfach mit hohem Kalkgehalt.
                            <br/><br/>
                            Im Steinfeld bieten karge Kalkschotterböden durch Ihre schnelle Durchwärmung ausgezeichnete Bedingungen für die heimischen Sorten. Vor etwa 19 Millionen Jahren überflutete das Jungtertiärmeer das ganze Wiener Becken, dessen Teil die Thermenregion ist.

                        </p>
                    </div>
                    <div className="col-6">
                        <p className="narrow">Veranschaulicht wird dies durch die vielen Reste von Muscheln, Schnecken und anderen Meeresbewohnern in den Böden und deren hohen Kalkanteil.
                            <br/><br/>
                            Zahlreiche fossile Tier- und Pflanzenfunde liefern Hinweise darauf, dass die einstigen Lebensbedingungen mit jenen des heutigen Mittelmeerraums vergleichbar sind. Vor etwa sechs Millionen Jahren verlandete das Wiener Becken und zurück blieben reiche Ablagerungen von Tegel, Schotter sowie tonhaltigen Sanden. </p>
                        <img alt=""  src="/images/geologie.webp" style={{mixBlendMode:"multiply"}} className="end" width="626" height="194"/>
                    </div>
                </div>
            </section>
            <section className="background_light ">
                <span  className="anchor" id="klima" ></span>
                <div className="horizontal">
                    <div className="col-6 left">
                        <h3>Klima</h3>
                        <p>Basis für den Charakter eines Weins ist das Zusammenspiel von Boden und Klima. In der Thermenregion ist dieses Zusammenspiel von besonderer Finesse und Vielfalt.
                            <br/><br/>
                            Die Weinreben profitieren hier vom pannonischen-subkontinentalen Klimaeinfluss, mit heißen Sommern und trockenem Witterungsverlauf im Herbst sowie 1800 Sonnenstunden im Jahr. Ständige Luftbewegung lässt im Herbst die Trauben nach Tau oder Regen rasch abtrocknen. Genau genommen besteht die Thermenregion aus einem nördlichen und einem südlichen Bereich.
                            <br/><br/>
                            Während der nördliche Teil eine submontane Stufe des niederösterreichischen Alpenostrandes darstellt, öffnet sich das Gebiet gen Süden als ebenes bis sanft geneigtes Gelände des Wiener Beckens. Damit verbunden sind sowohl klimatische als auch geologische Unterschiede.
                        </p>
                    </div>
                    <div className="col-6 vertical-center">
                        <img alt=""  src="/images/klima_1.png" style={{width:"80%"}} width="505" height="287"/>
                    </div>
                </div>
                <div className="horizontal">
                    <div className="col-6 vertical-center left">
                        <img alt=""  src="/images/klima_2.png" style={{width:"80%"}} width="674" height="369"/>
                    </div>
                    <div className="col-6">
                        <p>
                            Nicht von ungefähr sind im nördlichen Teil mehr Rotgipfler & Zierfandler zu finden und im südlichen Teil die Sorten aus der Burgunderfamilie & Zweigelt.
                            In der Vegetationsperiode von April bis Oktober beträgt die durchschnittliche Jahrestemperatur 9,9 Grad Celsius, während das Mittel der jährlichen Niederschlagsmenge bei 500 Millimetern liegt.
                            <br/><br/>
                            Diese Klimadaten besagen in Verbindung mit dem Breitengrad (48°20́), dass die Thermenregion dem kühleren Klimabereich hinzuzurechnen ist. Sie befindet sich damit etwa in Gesellschaft mit den französischen Gebieten Loire, Champagne und Burgund sowie Deutschland und der Schweiz.

                        </p>
                    </div>
                </div>
                <div className="horizontal">
                    <div className="col-6">
                        <p>
                            Durch den Wienerwald mit dem Anninger (675 Meter) und dem Lindkogel (834 Meter) als markante Erhebungen ist die Thermenregion vor starken West- und Nordwestwinden geschützt. Zugleich genießen die Reben hier die Vorzüge eines sogenannten Randklimas. Charakteristisch dafür sind große Temperaturunterschiede zwischen Tag und Nacht.
                            <br/><br/>
                            Tagsüber forcieren ausreichend Sonnenstunden die Zuckerbildung in den Beeren, während nächtliche kühle Luftströmungen aus dem Wienerwald – respektive aus dem Alpenvorland – für die frische Frucht, feine Aromaausprägung und Säure verantwortlich sind.
                        </p>
                    </div>
                    <div className="col-6">
                        <img alt=""  src="/images/klima_3.png" style={{width:"80%"}} width="729" height="366"/>
                    </div>
                </div>

            </section>
        </Layout>
    )
}